module.exports = "ul.social-footer {\n  color: #696a67;\n  padding: 0px;\n  margin: 0px; }\n  ul.social-footer li {\n    display: inline-block;\n    margin: 0px 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/content/content-layout.component.scss
// module id = ./src/app/layouts/content/content-layout.component.scss
// module chunks = main